import { RouteCollapsingLevel } from '../../../_shared/constants/routeCollapsingLevel.enum';
import { type MapSettingsDataAction } from '../data/mapSettingsData.action';
import { MAP_SETTINGS_REMOVE_ACTIVE_ITEMS } from '../data/mapSettingsData.actionTypes';
import { type MapSettingsDirectionsAction } from './mapSettingsDirections.action';
import {
  addOrUpdateRoute, clearDirectionsRoutes, removeRouteFromDirections,
} from './mapSettingsDirections.actionCreators';
import {
  MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE,
  MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS,
} from './mapSettingsDirections.actionTypes';
import { type MapSettingsDirectionsState } from './mapSettingsDirections.state';

export const mapSettingsDirectionsInitialState: MapSettingsDirectionsState = {
  selectedCollapsing: RouteCollapsingLevel.Routes,
  canDragRoutes: false,
  shouldBeginAtUserLocation: false,
  areMarkersCollapsed: false,
  routes: [],
};

export const mapSettingsDirectionsReducer = (
  state = mapSettingsDirectionsInitialState,
  action: MapSettingsDirectionsAction | MapSettingsDataAction
): MapSettingsDirectionsState => {

  if (addOrUpdateRoute.match(action)) {
    const { route } = action.payload;
    const indexIfExists = state.routes.findIndex(r => r.id === route.id);
    const routes =
      indexIfExists === -1
        ? [...state.routes, route]
        : state.routes.map((r, i) => (i === indexIfExists ? route : r));

    return {
      ...state,
      routes,
    };
  }
  else if (removeRouteFromDirections.match(action)) {
    return {
      ...state,
      routes: state.routes.filter(({ id }) => id !== action.payload.route.id),
    };
  }
  else if (clearDirectionsRoutes.match(action)) {
    return {
      ...state,
      routes: [],
    };
  }

  switch (action.type) {
    case MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS: {
      return {
        ...state,
        selectedCollapsing: action.payload.selectedCollapsing,
        canDragRoutes: action.payload.canDragRoutes,
        shouldBeginAtUserLocation: action.payload.shouldBeginAtUserLocation,
        areMarkersCollapsed: action.payload.areMarkersCollapsed,
      };
    }

    case MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE:
      return {
        ...state,
        routes: state.routes.map(r => r.id === action.payload.routeId ? action.payload.route : r),
      };

    case MAP_SETTINGS_REMOVE_ACTIVE_ITEMS:
      return {
        ...state,
        routes: [],
      };

    default:
      return state;
  }
};
